"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumberInput = void 0;
const react_1 = __importDefault(require("react"));
const react_ioc_1 = require("@servicetitan/react-ioc");
const design_system_1 = require("@servicetitan/design-system");
const culture_1 = require("@servicetitan/culture");
const process_value_1 = require("./process-value");
const get_formatted_string_1 = require("./get-formatted-string");
const accounting_1 = require("accounting");
const ARROW_UP_KEY = 38;
const ARROW_DOWN_KEY = 40;
exports.NumberInput = (_a) => {
    var { value, onChange, onFocus, onBlur, emptyValue, decimalPlaces, useEmptyThousandsSeparator, min, max, useKeyboardNavigation, formatNumber = accounting_1.formatNumber } = _a, props = __rest(_a, ["value", "onChange", "onFocus", "onBlur", "emptyValue", "decimalPlaces", "useEmptyThousandsSeparator", "min", "max", "useKeyboardNavigation", "formatNumber"]);
    const [{ NumberFormat: { NumberGroupSeparator: thousandsSeparator = ',', NumberDecimalSeparator: decimalSeparator = '.', }, } = { NumberFormat: {} },] = react_ioc_1.useOptionalDependencies(culture_1.CULTURE_TOKEN);
    const getFormattedValue = react_1.default.useCallback(() => get_formatted_string_1.getFormattedString(value, {
        emptyValue,
        precision: decimalPlaces,
        separators: {
            thousand: useEmptyThousandsSeparator ? '' : thousandsSeparator,
            decimal: decimalSeparator,
        },
    }, formatNumber), [
        decimalPlaces,
        decimalSeparator,
        emptyValue,
        thousandsSeparator,
        useEmptyThousandsSeparator,
        value,
        formatNumber,
    ]);
    const [isFocused, setIsFocused] = react_1.default.useState(false);
    const [state, setState] = react_1.default.useState({
        numberValue: value,
        stringValue: getFormattedValue(),
    });
    react_1.default.useEffect(() => {
        if (isFocused) {
            return;
        }
        setState({
            numberValue: value,
            stringValue: getFormattedValue(),
        });
    }, [value, getFormattedValue, isFocused]);
    const handleChange = (_0, { value }) => {
        updateValue(value);
    };
    const handleKeyDown = (event) => {
        var _a;
        if (event.keyCode === ARROW_UP_KEY || event.keyCode === ARROW_DOWN_KEY) {
            const newValue = ((_a = state.numberValue) !== null && _a !== void 0 ? _a : 0) + (event.keyCode === ARROW_UP_KEY ? 1 : -1);
            updateValue(String(newValue));
            event.preventDefault();
        }
    };
    const updateValue = (value) => {
        const newState = process_value_1.processValue(value, {
            emptyValue,
            precision: decimalPlaces,
            separators: {
                thousand: thousandsSeparator,
                decimal: decimalSeparator,
            },
            range: {
                min,
                max,
            },
        }, formatNumber);
        setState(newState);
        onChange(newState.numberValue);
    };
    const handleFocus = (event) => {
        setIsFocused(true);
        if (onFocus) {
            onFocus(event);
        }
    };
    const handleBlur = (event) => {
        setState({
            numberValue: value,
            stringValue: getFormattedValue(),
        });
        setIsFocused(false);
        if (onBlur) {
            onBlur(event);
        }
    };
    return (react_1.default.createElement(design_system_1.Input, Object.assign({}, props, { value: state.stringValue, onChange: handleChange, onFocus: handleFocus, onBlur: handleBlur, onKeyDown: useKeyboardNavigation ? handleKeyDown : undefined })));
};
//# sourceMappingURL=number-input.js.map